var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturnLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7147 8.27246L10.3023 5.4187C10.8056 5.01835 10.8056 4.25385 10.3023 3.8535L6.7147 0.999733",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0718 14.1815C1.31629 13.1406 0.946828 11.9507 1.00617 10.7497C1.06552 9.5487 1.55124 8.38561 2.40713 7.39508C3.26301 6.40455 4.45405 5.62709 5.84238 5.15268C7.23071 4.67827 8.75956 4.52632 10.2519 4.71441",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2853 14.0908L8.69771 16.9446C8.19441 17.3449 8.19441 18.1094 8.69771 18.5098L12.2853 21.3635",
    stroke: "#00A651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9282 8.18182C17.6729 9.20784 18.0427 10.3789 17.9961 11.563C17.9494 12.7472 17.4881 13.8975 16.6641 14.8844C15.84 15.8713 14.686 16.6556 13.332 17.1491C11.9779 17.6425 10.4776 17.8255 8.99985 17.6773",
    stroke: "#00A651",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnLight);
export default __webpack_public_path__ + "static/media/return_light.99d813486954aefab6b722e80a5a2960.svg";
export { ForwardRef as ReactComponent };